import React, { useEffect, useRef, useState } from 'react';
import * as rsuite from 'rsuite';

import Layout from '../../Layout/PrivateLayout.js';
import * as General from '../General/General.js';
import { trackPromise } from 'react-promise-tracker';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import * as BiIcon from "react-icons/bi";
import {Modal} from "react-bootstrap";
import Delete from '../Delete/Delete.js';
import Drp_DocSettingType from '../AccountDocSettings/Drp_DocSettingType.js';
import Drp_DocSettingUsedIn from '../AccountDocSettings/Drp_DocSettingUsedIn.js';




const DocTypeIndex = () => {

    //#region Const
    const toaster = rsuite.useToaster();
    let navigate = useNavigate();
    const DeleteRef = useRef()
    const TypeRef1 = useRef()
    const TypeRef2 = useRef()
    const TypeRef3 = useRef()
    const TypeRef4 = useRef()
    const TypeRef5 = useRef()
    const TypeRef6 = useRef()
    const TypeRef7 = useRef()
    const TypeRef8 = useRef()
    const UsedInRef = useRef()
    const UsedInSearchRef = useRef()
    const TypeSearchRef = useRef()
    const [DocTypeList, setDocTypeList] = useState([]);
    const [UsedInList, setUsedInList] = useState([]);
    const [Id, setId] = useState(General.GuidEmpty());

    const [Title, setTitle] = useState('');
    const [Rels, setRels] = useState([]);
    const [DocSettingUsedIn, setDocSettingUsedIn] = useState(0);
    const [IsActive, setIsActive] = useState(-1);

    const [TitleSearch, setTitleSearch] = useState("");
    const [DocSettingUsedInSearch, setDocSettingUsedInSearch] = useState(-1);
    const [DocSettingTypeSearch, setDocSettingTypeSearch] = useState(-1);
    const [ShowModal, setShowModal] = React.useState(false);
    const [sortColumn, setSortColumn] = React.useState();
    const [sortType, setSortType] = React.useState();
    const [loading, setLoading] = React.useState(false)

    //#endregion

    //#region Methods


    const ChangeTab = (eventKey) => {
        setDocSettingUsedIn(eventKey);
        setTimeout(() => {
            if (eventKey = 1)
                TypeRef1.current.Bind(-1, eventKey, 0, Rels)
            if (eventKey = 2)
                TypeRef2.current.Bind(-1, eventKey, 0, Rels)
            if (eventKey = 3)
                TypeRef3.current.Bind(-1, eventKey, 0, Rels)
            if (eventKey = 4)
                TypeRef4.current.Bind(-1, eventKey, 0, Rels)
            if (eventKey = 5)
                TypeRef5.current.Bind(-1, eventKey, 0, Rels)
            if (eventKey = 6)
                TypeRef6.current.Bind(-1, eventKey, 0, Rels)
            if (eventKey = 7)
                TypeRef7.current.Bind(-1, eventKey, 0, Rels)
            if (eventKey = 8)
                TypeRef8.current.Bind(-1, eventKey, 0, Rels)

        }, 1000);
    }

    const Search = () => {
        var RequestOptions = {
            data: {
                'Title': '',
                'DocSettingUsedIn': DocSettingUsedInSearch,
                'DocSettingType': DocSettingTypeSearch,
                'IsActive': -1
            },
            url: General.ApiRoute() + "/Account_DocType/Search",
            method: "post",
            withCredentials: true,

            headers: {
                'ApiKey': General.APIKey(),
                'Content-Type': 'application/json'
            }
        }
        trackPromise(
            axios(RequestOptions)
                .then(result => {
                    var tmp = []
                    for (var i = 0; i < result.data.length; i++) {
                        tmp.push({
                            Row: i + 1,
                            Id: result.data[i].id,
                            Title: result.data[i].title,
                            IsActive: result.data[i].isActive,
                            DocSettingUsedIn: result.data[i].docSettingUsedIn,
                            DocSettingUsedIn_Comment: result.data[i].docSettingUsedIn_Comment,

                        })
                    }
                    setDocTypeList(tmp)

                })
                .catch((error) => {
                    console.dir(error)
                })
        )
    }

    const handleSortColumn = (sortColumn, sortType) => {
        setLoading(true);
        setTimeout(() => {
            setLoading(false);
            setSortColumn(sortColumn);
            setSortType(sortType);
        }, 500);
    };


    const Reset = () => {
        setTitle("");
        setId(-1);
        setIsActive(true);
        setDocSettingUsedIn(0);
        setRels([]);
    }

    const Save = () => {

        if (Title == "") {
            toaster.push(General.ShowMessage('error', General.ErrorMessage("عنوان، اجباری می باشد")), 'topCenter')
            return;
        }
        if (Rels.length == 0) {
            toaster.push(General.ShowMessage('error', General.ErrorMessage("نوع اجباری می باشد")), 'topCenter')
            return;
        }

        var RequestOptions = {
            data: {
                "Id": Id,
                "Title": Title,
                // "DocSettingUsedIn": DocSettingUsedIn,
                "Rels": Rels,
                "IsActive": IsActive ? 1 : 0,
            },
            url: General.ApiRoute() + "/Account_DocType/Save",
            method: "post",
            withCredentials: true,

            headers: {
                'ApiKey': General.APIKey(),
                'Content-Type': 'application/json'
            }
        }


        trackPromise(
            axios(RequestOptions)
                .then(function (result) {
                    if (result.data == "OK") {
                        toaster.push(General.ShowMessage('success', General.SuccessMessage("ذخیزه شده است")), 'topCenter')

                        Search();
                        if (Id == General.GuidEmpty()) {
                            setTitle("");
                            setIsActive(true);
                            setDocSettingUsedIn(0);
                            setRels([]);
                            // TypeRef1.current.Bind(-1, -1, 0, [])
                        }
                        else {
                            Reset();
                            setShowModal(false);

                        }
                    }
                    else {
                        toaster.push(General.ShowMessage('error', General.ErrorMessage(result.data)), 'topCenter')

                    }
                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')

                })
        )
    }

    const ShowDelete = (id, title) => {
        DeleteRef.current.Get(32, id, title);
    }

    const ShowEdit = (Id) => {
        Reset();
        setId(Id);
        setShowModal(true);
        trackPromise(
            fetch(General.ApiRoute() + '/Account_DocType/GetById', {
                method: 'Get',
                headers: {
                    'ApiKey': General.APIKey(),
                    'Id': Id
                },
                credentials: 'include'
            })
                .then(res => res.json())
                .then(result => {
                    setTitle(result.title);
                    setDocSettingUsedIn(result.docSettingUsedIn);
                    setIsActive(result.isActive == 0 ? false : true);
                    setRels(result.rels);
                    console.dir(result.rels)

                    // setTimeout(() => {
                    //     TypeRef1.current.Bind(-1, result.docSettingUsedIn, 0, result.rels)
                    // }, 1000);

                })
        )
    }

    const ShowNew = () => {
        setShowModal(true);
        Reset();
        setTimeout(() => {
            TypeRef1.current.Bind(-1, -1, 0, [])
            // UsedInRef.current.Bind(-1)

        }, 1000);
    }

    const CheckPermission = () => {
        var myHeaders = new Headers();
        myHeaders.append("ApiKey", General.APIKey());
        myHeaders.append("Page", 32);
        myHeaders.append("Operation", 0);

        var requestOptions = {
            method: "Get",
            headers: myHeaders,
            credentials: 'include'

        };
        trackPromise(
            fetch(General.ApiRoute() + "/Common/CheckPermission", requestOptions)
                .then(response => response.text())
                .then(result => {
                    if (result.toString() != "OK") {
                        navigate("/AccessDenied");
                    }
                    else {
                        Search();
                        UsedInSearchRef.current.Bind(-1)
                        TypeSearchRef.current.Bind(-1, -1)
                        UsedInRef.current.Bind(-1, 0);

                    }
                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')
                })
        )
    }


    useEffect(() => {
        CheckPermission();
        document.title = "انواع سند حسابداری";
    }, [])
    //#endregion



    return (

        <Layout title='انواع سند حسابداری'>


            <div className="h-100 p-1">
                <rsuite.Panel className="bg-white h-10 ">
                    <rsuite.Grid fluid>
                        <rsuite.Row>
                            <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className="text-left" >
                                <rsuite.Button appearance="primary" size="xs" className="m-1" onClick={() => Search()}>  جستجو</rsuite.Button>
                                <rsuite.Button appearance="primary" color="green" size="xs" className="m-1" onClick={ShowNew}>  جـــدید</rsuite.Button>
                            </rsuite.Col>
                        </rsuite.Row>
                    </rsuite.Grid>
                    <hr />
                    <rsuite.Row className='p-1'>
                        <rsuite.Col xxl={8} xl={8} lg={8} md={8} sm={24} xs={24}>
                            <label>عنوان</label>
                            <rsuite.Input value={TitleSearch} className='FocusItem' onChange={(e) => setTitleSearch(e)} />
                        </rsuite.Col>
                        <rsuite.Col xxl={8} xl={8} lg={8} md={8} sm={24} xs={24}>
                            <label> نوع </label>
                            <Drp_DocSettingUsedIn value={DocSettingUsedInSearch} onChange={(value, title) => (setDocSettingUsedInSearch(value), TypeSearchRef.current.Bind(-1, value))} ref={UsedInSearchRef} />
                            <Drp_DocSettingUsedIn onSubmit={(value) => setUsedInList(value)} ref={UsedInRef} />

                        </rsuite.Col>
                        <rsuite.Col xxl={8} xl={8} lg={8} md={8} sm={24} xs={24}>
                            <label> نوع عملیات</label>
                            <Drp_DocSettingType value={DocSettingTypeSearch} onChange={(value, title) => (setDocSettingTypeSearch(value))} ref={TypeSearchRef} />
                        </rsuite.Col>
                    </rsuite.Row>
                    <div className="h-90 p-1">
                        <div className="h-100-y">

                            <rsuite.Panel className="bg-white mt-2">

                                <rsuite.Table
                                    height={620}
                                    data={DocTypeList.sort((a, b) => {
                                        let x = a[sortColumn];
                                        let y = b[sortColumn];
                                        if (typeof x === 'string') {
                                            x = x.charCodeAt();
                                        }
                                        if (typeof y === 'string') {
                                            y = y.charCodeAt();
                                        }
                                        if (sortType === 'asc') {
                                            return x - y;
                                        } else {
                                            return y - x;
                                        }
                                    })}
                                    sortColumn={sortColumn}
                                    sortType={sortType}
                                    onSortColumn={handleSortColumn}
                                    loading={loading}

                                >
                                    <rsuite.Table.Column className="w-10p" align="center" fixed sortable>
                                        <rsuite.Table.HeaderCell>#</rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell dataKey="Row" />
                                    </rsuite.Table.Column>

                                    <rsuite.Table.Column flexGrow={2} fullText sortable resizable>
                                        <rsuite.Table.HeaderCell>شرح</rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell dataKey="Title" />
                                    </rsuite.Table.Column>
                                    {/* <rsuite.Table.Column flexGrow={1} fullText sortable resizable>
                                        <rsuite.Table.HeaderCell>نوع </rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell dataKey="DocSettingUsedInComment" />
                                    </rsuite.Table.Column> */}

                                    <rsuite.Table.Column fullText width={100} resizable>
                                        <rsuite.Table.HeaderCell>فعال   </rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell>
                                            {(rowData) => {
                                                return <>

                                                    {rowData.IsActive == 1 ?

                                                        <BiIcon.BiCheckCircle className="text-success fs-6" />
                                                        :
                                                        <BiIcon.BiXCircle className="text-danger fs-6" />
                                                    }
                                                </>


                                            }}

                                        </rsuite.Table.Cell>
                                    </rsuite.Table.Column>

                                    <rsuite.Table.Column width={60} fixed="right" >
                                        <rsuite.Table.HeaderCell></rsuite.Table.HeaderCell>

                                        <rsuite.Table.Cell>
                                            {(rowData) => {
                                                return <>
                                                    <rsuite.Whisper placement="autoVerticalStart" trigger="click" speaker={
                                                        <rsuite.Popover full className='PopoverMenu'>
                                                            <rsuite.Dropdown.Menu  >
                                                                <rsuite.Dropdown.Item onClick={() => ShowEdit(rowData.Id)}>ویرایش</rsuite.Dropdown.Item>
                                                                <rsuite.Dropdown.Item onClick={() => ShowDelete(rowData.Id, rowData.Title)}>حذف</rsuite.Dropdown.Item>
                                                            </rsuite.Dropdown.Menu>
                                                        </rsuite.Popover>
                                                    }>
                                                        <rsuite.IconButton appearance="subtle" icon={<BiIcon.BiDotsHorizontalRounded />} />
                                                    </rsuite.Whisper>
                                                </>
                                            }}
                                        </rsuite.Table.Cell>

                                    </rsuite.Table.Column>
                                </rsuite.Table>

                            </rsuite.Panel>

                        </div>
                    </div>

                </rsuite.Panel >
            </div >




            <Modal show={ShowModal} onHide={() => setShowModal(false)} size="lg" backdrop="static" keyboard={false} >
                <Modal.Header >
                    <Modal.Title className='fs-5'><b>تعریف  </b></Modal.Title>
                </Modal.Header>
                <Modal.Body >
                    <rsuite.Grid fluid>
                        <rsuite.Row className="p-1">
                            <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                <BiIcon.BiSolidStar className={Title == "" ? 'text-danger' : 'hide'} />  <label>شرح</label>
                                <rsuite.Input value={Title} onChange={(e) => setTitle(e)} />
                            </rsuite.Col>

                            <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                <rsuite.Checkbox onChange={(e, checked) => setIsActive(checked)} checked={IsActive} value={IsActive} /> &nbsp; فعال می باشد
                            </rsuite.Col>
                            <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                <rsuite.Tabs defaultActiveKey={DocSettingUsedIn.toString()}
                                    onSelect={(eventKey) => ChangeTab(eventKey)} vertical appearance="subtle">

                                    {UsedInList.map(item => (

                                        item.Id != -1 ?

                                            <rsuite.Tabs.Tab eventKey={item.Id} title={item.Title}>
                                                {item.Id == 1 ?
                                                    <Drp_DocSettingType value={Rels} onChange={(value, title) => (setRels(value))} ref={TypeRef1} />
                                                    :item.Id == 2 ?
                                                    <Drp_DocSettingType value={Rels} onChange={(value, title) => (setRels(value))} ref={TypeRef2} />
                                                    :item.Id == 3 ?
                                                    <Drp_DocSettingType value={Rels} onChange={(value, title) => (setRels(value))} ref={TypeRef3} />
                                                    :item.Id == 4 ?
                                                    <Drp_DocSettingType value={Rels} onChange={(value, title) => (setRels(value))} ref={TypeRef4} />
                                                    :item.Id == 5 ?
                                                    <Drp_DocSettingType value={Rels} onChange={(value, title) => (setRels(value))} ref={TypeRef5} />
                                                    :item.Id == 6 ?
                                                    <Drp_DocSettingType value={Rels} onChange={(value, title) => (setRels(value))} ref={TypeRef6} />
                                                    :item.Id == 7 ?
                                                    <Drp_DocSettingType value={Rels} onChange={(value, title) => (setRels(value))} ref={TypeRef7} />
                                                    :
                                                    <Drp_DocSettingType value={Rels} onChange={(value, title) => (setRels(value))} ref={TypeRef8} />

                                                }

                                            </rsuite.Tabs.Tab>
                                            :
                                            <></>

                                    ))}
                                </rsuite.Tabs>
                            </rsuite.Col>


                        </rsuite.Row>

                    </rsuite.Grid>
                </Modal.Body>
                <Modal.Footer>
                    <rsuite.Button appearance="primary" color="green" onClick={Save}>
                        ذخیره
                    </rsuite.Button>
                    <rsuite.Button appearance="subtle" onClick={() => setShowModal(false)}>
                        بستن
                    </rsuite.Button>

                </Modal.Footer>
            </Modal>

            <Delete ref={DeleteRef} onSubmit={Search} />
        </Layout >


    )
}


export default DocTypeIndex;